import { ThemeLibrarySettings } from "@/components/editor/themes/theme-library-settings";
import { useActiveWorkspaceId } from "@/contexts/workspace-context";

export function ThemeLibrary(): JSX.Element {
  const workspaceId = useActiveWorkspaceId();

  if (!workspaceId) {
    return (
      <div className="flex items-center justify-center h-full">
        <p className="text-sm text-muted-foreground">
          Workspace not found. Please sign in.
        </p>
      </div>
    );
  }

  return (
    <div className="h-full">
      <ThemeLibrarySettings workspaceId={workspaceId} />
    </div>
  );
}
